module.exports = __webpack_public_path__ + "media/warranty/proof-of-roof-fecfdd0f.png";